import React from 'react'
import { FileRejection, useDropzone } from 'react-dropzone'
import { useTranslation } from 'react-i18next'
import UploadFile from '@node-space/storybook-components/dist/UploadFile'
import { dropZoneAcceptedDocuments } from 'utils/documents'
import { FileUpload } from './FileUpload'

export const MassPayoutFileUpload = () => {
  const { t } = useTranslation()
  const onFileDrop = (_acceptedFiles: unknown[], _fileRejections: FileRejection[]) => {
    // TODO: Handle file drop
  }

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: onFileDrop,
    multiple: false,
    accept: dropZoneAcceptedDocuments,
  })

  return (
    <UploadFile
      full
      isDragActive
      defaultMessage={null}
      file={null}
      getInputProps={getInputProps}
      getRootProps={getRootProps}
      name="mass-payouts-file-upload-input"
      textList={{
        dropFile: <FileUpload />,
        replaceFile: <FileUpload />,
        uploadFile: <FileUpload />,
        uploadingFile: t('massPayouts.validatingFileUpload'),
        fileRequired: t('fieldRequired', { field: t('documents.file') }),
      }}
      errorMessage={null}
      title=""
      isUploading={false}
    />
  )
}
